<template>
    <div class="row justify-content-left">
        <div class="col-md-12">
            <ol class="breadcrumb" :class="{'active': isDropdownOpen}">
                <li class="breadcrumb-item" v-for="(breadcrumb, i) in getBreadcrumbParents"
                    :class="{active:i===getBreadcrumbParents.length-1}">
                    <a :href='regionRelativeUrl(breadcrumbUrl(breadcrumb))'
                       @click="changeUrl()">{{ breadcrumb.name }}</a>
                </li>

                <li v-if="getBreadcrumbChildrens.length || filteredPublicCategories.length || nearbyLocations.length"
                    class="breadcrumb-item breadcrumb-item-dropdown dropdown">

                    <a class="dropdown-toggle breadcrumb-dropdown-search" @click="closeFilter()" href=""
                       role="button" id="breadcrumbDropdown"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>{{ location.locale_name }}</span>
                    </a>

                    <div class="dropdown-menu breadcrumb-dropdown-menu" aria-labelledby="breadcrumbDropdown">
                        <div class="d-none breadcrumb-dropdown-menu--mobile-header">
                            <button @click="closeDropdown" class="btn btn-rebrand-grey-outline btn-rebrand-sm">
                                {{ translate.home.back }}
                            </button>
                        </div>
                        <div class="row">
                            <div class="col-md-3 breadcrumb-item-dropdown-public" v-if="getBreadcrumbChildrens.length">
                                <h2>{{ translate.home.searchAreasIn }}
                                    {{ location.locale_name }}
                                </h2>

                                <ul v-if="getBreadcrumbChildrens.length">
                                    <li v-for="child in getBreadcrumbChildrens" value="">
                                        <a :href='regionRelativeUrl(breadcrumbUrl(child))'
                                           @click="changeUrl()">
                                            {{ child.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="col-md-3 breadcrumb-item-dropdown-popular"
                                 v-if="filteredPublicCategories.length">
                                <h2>{{ translate.home.popularIn }} {{ location.locale_name }}</h2>
                                <ul>
                                    <li v-for="category in filteredPublicCategories">
                                        <a :href="regionRelativeUrl(category.url)">{{
                                                category.category
                                            }}{{ translate.home.inLocation }}{{ location.locale_name }}</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="col-md-3 breadcrumb-item-dropdown-popular" v-if="nearbyLocations.length">
                                <h2>{{ translate.home.nearbyLocations }}</h2>
                                <ul>
                                    <li v-for="location in nearbyLocations">
                                        <a :href="regionRelativeUrl(location.url)">{{ location.name }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="breadcrumb-item" v-else>
                    {{ location.locale_name }}
                </li>
            </ol>
        </div>
    </div>
</template>

<script>
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {disableScroll, enableScroll} from "@/core/utils/helpers/GlobalCssHelpers";
import {breadcrumbUrl} from "@/core/utils/helpers/breadcrumbs/breadcrumbUrlHelper";

const data = () => {
    return {
        store: $store,
        isDropdownOpen: false,
    }
};

function closeFilter() {
    this.$emit('closeFilter');
}

function getCategoryUrlFromUrl() {
    const rawPathName = _.get(this, 'location.pathname', (typeof window === 'undefined' ? '' : window.location.pathname));
    // Strip the region prefix before parsing so the derived categoryPath matches the
    // BARE category.path (mirrors ProfileBreadcrumbsComponent). No-op pre-flip
    // (region-relative pathname) and for Germany (no region prefix).
    let pathName = this.pathWithoutRegion(rawPathName).split('/');

    pathName.shift();
    pathName.pop();

    if (pathName.length > 1) {
        const seoUrls = [];
        _.forEach(this.settings.filter, (filter) => {
            seoUrls.push(_.trim(filter.url, '/'));
        })

        const pathNameString = pathName.join('/');

        if (seoUrls.includes(pathNameString)) {
            return pathNameString;
        }

        pathName.pop();
    }

    pathName = pathName.join('/');

    return pathName;
}

function changeUrl() {
    this.store.commit('setLoading', true);
}

function isBreadcrumbCategoryPublic(publicCategories, categoryPath) {
    if (!publicCategories || !publicCategories.length) {
        return false;
    }

    return !!_.find(publicCategories, (category) => category.path === categoryPath);
}

function closeDropdown() {
    $('#breadcrumbDropdown').dropdown('hide');
    $('#breadcrumbDropdown').attr('aria-expanded', 'false');
}

export default {
    data,
    computed: {
        ...mapState(['translate', 'settings']),
        categoryPath() {
            return `/${this.getCategoryUrlFromUrl()}/`;
        },
        countryDisplayName() {
            return this.countryNameShort || this.countryName;
        },
        countryBreadcrumb() {
            let url;

            if (this.categoryPath === `/${this.settings.defaultCategorySlug}/`) {
                url = this.settings.defaultSearchUrl;
            } else {
                url = this.categoryPath;
            }

            return {
                name: this.countryDisplayName,
                slug: '',
                url,
            };
        },
        getBreadcrumbParents() {
            let parents = _.reverse(_.cloneDeep(_.get(this, 'location.breadcrumbs.parent', [])));

            if (parents.length) {
                parents = _.filter(parents, (p) => this.isBreadcrumbCategoryPublic(p.publicCategories, this.categoryPath));
                parents.unshift(this.countryBreadcrumb);
                return parents;
            }

            const localeName = _.get(this, 'location.locale_name');
            if (localeName === this.countryName || (!!this.countryNameShort && localeName === this.countryNameShort)) {
                return [];
            }

            return [this.countryBreadcrumb];
        },
        getBreadcrumbChildrens() {
            let childs = _.reverse(_.cloneDeep(_.get(this, 'location.breadcrumbs.children', [])));

            if (childs.length) {
                childs = _.filter(childs, (p) => this.isBreadcrumbCategoryPublic(p.publicCategories, this.categoryPath));
                return _.sortBy(childs, 'name');
            }

            return [];
        },
        nearbyLocations() {
            const nearbyLocations = _.get(this, 'location.nearbyLocations', []);

            return nearbyLocations.map(location => {
                return {
                    name: location.germanName,
                    // Backend only returns nearby areas that have a public seo page for the
                    // category, so url is always a ready-to-render region-absolute path.
                    url: location.url,
                }
            });
        },
        filteredPublicCategories() {
            const categories = _.get(this, 'location.publicCategories', []);
            const pathname = (typeof window === "undefined") ? '' : window.location.pathname || '';

            return categories.filter(category => {
                return category.url && (category.url !== pathname) && (category.path !== this.categoryPath)
            });
        },
        ...mapState([
            'location',
            'settings',
            'countryName',
            'countryNameShort',
            'countrySlug',
        ]),
    },
    mixins: [regionsUrlMixin],
    methods: {
        closeFilter,
        getCategoryUrlFromUrl,
        isBreadcrumbCategoryPublic,
        changeUrl,
        closeDropdown,
        breadcrumbUrl(item) {
            return breadcrumbUrl(item, this.categoryPath);
        },
    },
    mounted() {
        $(this.$el).on('show.bs.dropdown', () => {
            this.isDropdownOpen = true;

            if (window.innerWidth <= 767) {
                disableScroll();
            }
        });
        $(this.$el).on('hide.bs.dropdown', () => {
            this.isDropdownOpen = false;

            if (window.innerWidth <= 767) {
                enableScroll();
            }
        });
    },
    beforeDestroy() {
        $(this.$el).off('show.bs.dropdown');
        $(this.$el).off('hide.bs.dropdown');

        enableScroll();
    },
}
</script>
